import { render, staticRenderFns } from "./huaweiPage.vue?vue&type=template&id=35c7e01b&scoped=true&"
import script from "./huaweiPage.vue?vue&type=script&lang=js&"
export * from "./huaweiPage.vue?vue&type=script&lang=js&"
import style0 from "./huaweiPage.vue?vue&type=style&index=0&id=35c7e01b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7e01b",
  null
  
)

export default component.exports